// extracted by mini-css-extract-plugin
module.exports = {"iconDefault":"#4b5258"};